export const dashboardEn = {
  DASHBOARD: 'Dashboard',
  DOWNLOAD_REPORT: 'Download Report',
  DEBTOR_COLLECTION_TITLE: 'Collections - Debtor Open AR',
  CREDIT_REQUEST: 'Credit Requests',
  CLIENT_DEBTOR_REQUEST: 'Client:Debtor Relationship Request',
  NEW_DEBTOR_REQUEST: 'New Debtor Request',
  VIEW_MORE: 'View More',
  FEE_EARNINGS: 'Fee Earnings',
  FUNDING: 'Funding',
  TOTAL_AMOUNT_FUNDED: 'Total amount funded',
  INVOICE_OVERVIEW: 'Invoice Overview',
  TOTAL: 'Total',
  PAST_DUE_INVOICES: 'Past Due Invoices',
  //START MICHAEL
  DASHBOARD_OVERVIEW: 'Dashboard Overview',
  AGING_BUCKETS_AMOUNTS: 'Aging Buckets Amounts',
  CHART_OPTIONS: 'Chart Options',
  AGING_BUCKETS_PERCENTAGE: 'Aging Buckets Percentage',
  FACTOR_PORTFOLIO: 'Factor Portfolio',
  DAILY_VOLUME: 'Daily Volume',
  APPROVED_INVOICE_AMOUNT: 'Approved Invoice Amount',
  FUNDED_INVOICE_AMOUNT: 'Funded Invoice Amount',
  TOTAL_AR: 'Total AR',
  AR_BALANCE: 'AR Balance',
  ESCROW_BALANCE: 'Escrow Balance',
  CASH_RESERVE_BALANCE: 'Cash Reserve Balance',
  TOP_5_CLIENTS_BY_NFE: 'Top 5 Clients by NFE',
  TOP_5_DEBTORS_BY_NFE: 'Top 5 Debtors by Open AR',
  RANK: 'Rank',
  CLIENT_NAME: 'Client Name',
  DEBTOR_NAME: 'Debtor Name',
  NFE_AMOUNT: 'NFE Amount',
  NO_CLIENTS_CREATED: 'No clients created',
  NO_DEBTORS_CREATED: 'No debtors created',
  //END MICHAEL

  //START PATRICIO
  AMOUNT_INELIGIBLE_DISPUTABLE: 'Ineligible/Disputed',
  TOTAL_FUNDS_EMPLOYED: 'Funds Employed',
  NET_FUNDS_EMPLOYED: 'Net Funds Employed',
  AVAILABLE_RESERVE: 'Available Reserve',
  CASH_RESERVE: 'Cash Reserve',
  UNAPPLIED_RESERVE: 'Unapplied Reserve',
  //END PATRICIO
}

export const dashboardEs: typeof dashboardEn = {
  DASHBOARD: 'Tablero',
  DOWNLOAD_REPORT: 'Descargar informe',
  DEBTOR_COLLECTION_TITLE: 'Colecciones - Deudor Open AR',
  CREDIT_REQUEST: 'Solicitudes de crédito',
  CLIENT_DEBTOR_REQUEST: 'Cliente: Solicitud de relación de deudor',
  NEW_DEBTOR_REQUEST: 'Nueva solicitud de deudor',
  VIEW_MORE: 'Ver más',
  FEE_EARNINGS: 'Ganancias de tarifas',
  FUNDING: 'Financiamiento',
  TOTAL_AMOUNT_FUNDED: 'Monto total financiado',
  INVOICE_OVERVIEW: 'Resumen de facturas',
  TOTAL: 'Total',
  PAST_DUE_INVOICES: 'Facturas vencidas',
  //START MICHAEL
  DASHBOARD_OVERVIEW: 'Resumen del tablero',
  AGING_BUCKETS_AMOUNTS: 'Montos por tramos de antigüedad',
  CHART_OPTIONS: 'Opciones de gráfico',
  AGING_BUCKETS_PERCENTAGE: 'Porcentaje por tramos de antigüedad',
  FACTOR_PORTFOLIO: 'Portafolio de factoring',
  DAILY_VOLUME: 'Volumen diario',
  APPROVED_INVOICE_AMOUNT: 'Monto de Facturas Aprobadas',
  FUNDED_INVOICE_AMOUNT: 'Monto de Facturas Financiadas',
  TOTAL_AR: 'Total AR',
  AR_BALANCE: 'Saldo de AR',
  ESCROW_BALANCE: 'Saldo de depósito en garantía',
  CASH_RESERVE_BALANCE: 'Saldo de reserva de efectivo',
  TOP_5_CLIENTS_BY_NFE: 'Top 5 Clientes por NFE',
  TOP_5_DEBTORS_BY_NFE: 'Top 5 Deudores por Saldo de AR',
  RANK: 'Posición',
  CLIENT_NAME: 'Nombre del Cliente',
  DEBTOR_NAME: 'Nombre del Deudor',
  NFE_AMOUNT: 'Monto NFE',
  NO_CLIENTS_CREATED: 'No hay clientes creados',
  NO_DEBTORS_CREATED: 'No hay deudores creados',
  //END MICHAEL

  //START PATRICIO
  AMOUNT_INELIGIBLE_DISPUTABLE: 'Ineligible/Disputable',
  TOTAL_FUNDS_EMPLOYED: 'Total de fondos empleados',
  NET_FUNDS_EMPLOYED: 'Fondos netos empleados',
  AVAILABLE_RESERVE: 'Reserva disponible',
  CASH_RESERVE: 'Reserva de efectivo',
  UNAPPLIED_RESERVE: 'Reserva no aplicada',
  //END PATRICIO
}
